module.exports = __webpack_public_path__ + "img/upper_pocket_entry_length.013d843a.png";